import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook para obter informações dinâmicas do site
 * Também aplica o favicon dinamicamente
 */
const useSiteInfo = () => {
  const [siteInfo, setSiteInfo] = useState({
    site_name: "MultiShop Brasil",
    logo_url: "",
    favicon_url: "",
    footer_text: "",
    footer_links: [],
    contact_email: "",
    contact_phone: "",
    instagram_url: "",
    facebook_url: "",
    cnpj: ""
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    const fetchSiteInfo = async () => {
      try {
        const response = await axios.get(`${API}/settings/site-info`, {
          signal: controller.signal,
          timeout: 3000
        });
        const data = response.data;
        setSiteInfo(prev => ({ ...prev, ...data }));
        
        // Apply favicon dynamically
        if (data.favicon_url) {
          applyFavicon(data.favicon_url);
        }
        
        // Update document title with site name
        if (data.site_name) {
          document.title = data.site_name;
        }
      } catch (error) {
        // Silently fail - use defaults
      } finally {
        setLoading(false);
      }
    };

    fetchSiteInfo();
    return () => controller.abort();
  }, []);

  return { siteInfo, loading };
};

/**
 * Apply favicon to the document
 */
function applyFavicon(faviconUrl) {
  if (!faviconUrl) return;
  
  // Remove existing favicons
  const existingLinks = document.querySelectorAll('link[rel*="icon"]');
  existingLinks.forEach(link => link.remove());
  
  // Create new favicon link
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = faviconUrl.endsWith('.ico') ? 'image/x-icon' : 'image/png';
  link.href = faviconUrl;
  document.head.appendChild(link);
  
  // Also add apple-touch-icon for iOS
  const appleLink = document.createElement('link');
  appleLink.rel = 'apple-touch-icon';
  appleLink.href = faviconUrl;
  document.head.appendChild(appleLink);
}

export default useSiteInfo;
